import API from '../api'
import deleteUrl from './paths'

export const deleteAdminEnquiry = (enquiryId) =>
	new Promise((resolve, reject) => {
		API.delete(deleteUrl.deleteEnquiry, { enquiryId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})

export const deleteItemInActiveEnquiry = (enquiryId, itemId) =>
	new Promise((resolve, reject) => {
		API.delete(deleteUrl.deleteEnquiryItem, { enquiryId, itemId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
